import { Button } from "@mui/material";
import i18n from "../../reducers/i18n";

import { ReactComponent as MessageSvg } from "../../assets/Messages.svg";
// import { ReactComponent as UserSvg } from "../../assets/User.svg";
import { ReactComponent as VerticalDivider } from "../../assets/VerticalDivider.svg";

function UserCard(props) {
  const t = i18n();
  return (
    <div className="userCard bxShadow">
      <div className="userInfo">
        <div className="bioWrapper">
          <div className="imageWrapper">
            <div className="mainImage">
              {/* <UserSvg /> */}
            </div>
            <div className="online"></div>
          </div>
          <div className="names">
            <div className="primary">{props.user.givenname} {props.user.surname}</div>
            <div className="secondary">
              <div className="status">{`${t.users?.tableStatus || "Status"}: Online`}</div>
              <div className="vDivider">
                <VerticalDivider />
              </div>
              <div className="status">{`${t.role || "Role"}: Administrator`}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="email">{props.user.email}</div>
      <div className="phones">
      <div className="phone1">+49 176 123456</div>
        <div className="vDivider">
          <VerticalDivider />
        </div>
        <div className="phone2">+49 8141 123456</div>
      </div>

      <Button startIcon={<MessageSvg />} sx={{ marginTop:"16px"}} variant="outlined">
        {t.users?.newMessage || "Neue Nachricht"}
      </Button>
    </div>
  );
}

export default UserCard;
